import { Card } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  &&& {
    border-radius: 1rem;
    box-shadow: 0 0.1rem 0.6rem rgba(0, 0, 0, 0.19);
    background-color: ${({ theme }) => theme.palette.white};
  }

  &&&&&& {
    p {
      margin: 0;
    }
    a {
      font-size: 1.2rem;
    }
  }
`;

export { StyledCard as Card };
